<template>
  <div>
    <div class="container">
      <div v-if="isDetail" class="detail">
        <div class="title">
          <span @click="handle_back()" class="left_text">{{ '<<项目公告' }} </span>
              <span class="center">{{ detail_data.TITLE }}</span>
              <span @click="handle_go(detail_data)" class="right_text"> 去竞价>> </span>
        </div>
        <!-- 文章内容 -->
        <div class="footerContent">
          <span class="status">
            项目分类: {{ detail_data.TYPE_NAME }}
          </span>

          <div class="time_box">
            <div class="time_item">
              报名截止时间: {{ detail_data.APPLY_END_TIME_TXT }}
            </div>
            <div class="time_item shuXian">
              竞价开始时间: {{ detail_data.BIDDING_START_TIME_TXT }}
            </div>
          </div>

          <div class="xmjs">
            <div class="xmjs_text">
              项目介绍:
            </div>
            <div class="content_text">
              <div v-html="detail_data.INTRO"></div>
            </div>
          </div>

          <div class="header_4">
            <div v-for="item, index in detail_data.INTRO_FILE_ARR" :key="index"
              :class="index != 4 || index != 9 ? 'shu_xian' : ''" class="file_item">
              <span style="max-width: 70%;" class="chaochu">{{ item.FILE_NAME }}</span>
              <!-- <span
                @click="download(item.FILEPATH)" class="xz">下载</span> -->

              <el-button @click="download(item.FILEPATH)" size="mini" type="primary">下载</el-button>

            </div>
          </div>

          <div class="form">
            <div class="footer_item">
              <div class="lable">
                图片展示:
              </div>
              <div style="display: flex;flex-wrap: wrap;">
                <div v-for="item, index in detail_data.IMAGES" :key="index" class="value item_box">
                  <el-image style="width: 123px; height: 123px;margin-right: 10px;" :src="item"
                    :preview-src-list="detail_data.IMAGES">
                  </el-image>
                  <!-- <img class="img_style" style="width: 123px;height: 123px;margin:0 14px 14px 0; " :src="item" alt=""> -->
                </div>
              </div>
            </div>
            <div v-if="detail_data.IS_UPLOAD == '1'" style="margin-bottom: 10px;" class="footer_item">
              <div class="lable">
                竞价前填写资料:
              </div>
              <div style="display: flex;flex-direction: column;">
                <span style="margin-bottom: 20px;">{{ detail_data.UPLOAD_DESC.UP_DESC || '资料说明' }}</span>
                <div style="display: flex;">
                  <a style="text-decoration-line: underline; color: #0256FF;font-size: 14px;margin-right: 8px;">
                    {{ detail_data.UPLOAD_DESC.UP_INFORMATION_ARR[0].FILE_NAME || '资料文件名称' }}
                  </a>

                  <el-button @click="download(detail_data.UPLOAD_DESC.UP_INFORMATION_ARR[0].FILEPATH)" size="mini"
                    type="primary">下载</el-button>
                </div>
              </div>
            </div>
            <div v-if="detail_data.IS_UPLOAD == '1'" class="footer_item">
              <div class="lable">
                文件上传截止时间:
              </div>
              <div class="upload1">
                <span class="footer_info">
                  {{ detail_data.UPLOAD_DESC.UP_END_TIME_TXT || '-' }}
                </span>
              </div>
            </div>
            <div v-if="detail_data.IS_NEED == '1'" class="footer_item">
              <div class="lable">
                保证金:
              </div>
              <div class="value">
                <div class="bzj">{{ detail_data.NEED_MONEY.MONEY }}元
                  <span style="color: #52A847;font-weight: normal;">(业务执行结束退)</span>
                </div>
                <!-- <span class="footer_info">
                    保证金缴纳时间： {{ detail_data.NEED_MONEY.MONEY_END_TIME_TXT }}
                  </span> -->
              </div>
            </div>
          </div>

        </div>
      </div>


      <!-- 资料说明 -->


    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: true,
      fileList: [],
      detail_data: {}, //公告信息详情
      isDetail: false,
      cli: 1,
      is_information: false, //资料说明
      list: [],//公告列表
      query: {
        page: 1,
        limit: 10,
      },
      total: 0,
      disabled: false,
    };
  },
  created() {
    this.get_list()
  },
  methods: {
    handle_back() {
      this.isDetail = false
      this.$emit('is_back')
    },
    handle_go(row) {
      console.log(row, 'rowwwwwwwwwwwww----->');
      // 将项目ID存入localStorage，供其他页面或组件使用
      localStorage.setItem('get_info_id', row.ID);
      // 使用 $nextTick 确保DOM更新后再触发事件
      this.$nextTick(() => {
        // 向父组件或其他监听者发送 'handleClick' 事件
        // 参数: 1 (标识操作类型), '12' (标识具体场景或来源), row (行数据)
        this.$emit('handleClick', 1, '12', row);
      });
    },
    handlePreview() {
    },
    handleRemove() {

    },
    beforeRemove() {

    },
    handleExceed() {

    },
    current_change(e) {
      this.query.page = e
      this.get_list()
    },
    // 下载合同
    download(e) {
      console.log(e, '-eeeeeee---->');
      window.location.href = e
    },
    // 获取公告信息列表
    async get_list() {
      const res = await this.$http.get('/api/project/get_project', {
        params: this.query
      })
      console.log(res, '----->resres');

      if (res.data.code == 200) {
        this.list = res.data.data.data
        this.total = res.data.data.total
        this.loading = false
      }
    },
    handleSwitch(e) {
      this.cli = e
      if (e == 2) {
        this.is_information = true
      } else {
        this.is_information = false
      }
    },
    // 获取公告信息详情
    async handleClick(e) {
      // this.
      const res = await this.$http.get('/api/project/get_project_info', {
        params: {
          id: e.ID
        }
      })
      if (res.data.code == 200) {
        this.detail_data = res.data.data
        this.isDetail = !this.isDetail
        this.isDetail = true
      }
      console.log(res, '----->');
    },
    handlePictureCardPreview(file) {
      console.log('Picture Card Preview:', file.url);
      window.open(file.url);
    },
    handleDownload(file) {
      console.log('Download image:', file.name);
      const link = document.createElement('a');
      link.href = file.url;
      link.download = file.name || 'downloaded_image';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  }
}
</script>

<style lang="scss" scoped>
.custom-pagination ::v-deep .el-pager .number {
  border-radius: 50% !important;
}

.container {
  width: 1200px;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px;
}

.left-nav {
  width: 200px;
  background: #f5f5f5;

  .nav-item {
    padding: 15px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;

    &.active {
      background: #c8102e;
      color: white;
    }

    i {
      margin-right: 10px;
    }
  }
}

.content {
  flex: 1;
  margin-left: 20px;
  height: 700px;

  .content-header {
    font-size: 16px;
    padding: 10px 0;
    border-bottom: 2px solid #c8102e;
  }

  .boxc {
    display: flex;
    margin-top: 20px;
  }

  .right {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
    padding-bottom: 20px;
    position: relative;
  }

  /* 新增表头样式 */
  .table-header {
    display: flex;
    padding: 10px 0;
    font-weight: bold;
    border-bottom: 2px solid #eee;
    background-color: #f9f9f9;

    .header-item {
      flex: 1;
      text-align: left;
    }
  }

  .list {

    .list-item {
      padding: 15px 0;
      display: flex;
      align-items: center;
      cursor: pointer;
      flex: 1;

      .item-time {
        display: flex;
        align-items: center;
        flex: 1;

        .text_ {
          width: 180px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .icon-doc {
        min-width: 10px;
        height: 10px;
        background: #EDEEF1;
        margin: 0 10px 0 10px;
        border-radius: 20px;
      }

      &:hover {
        color: #c8102e;
      }
    }
  }

  .pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .page {
      padding: 5px 10px;
      margin: 0 5px;
      cursor: pointer;

      &.active {
        background: #c8102e;
        color: white;
        border-radius: 2px;
      }
    }
  }
}

.detail {
  flex: 1;
  margin-left: 20px;
  min-height: 700px;

  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 8%;
    margin-bottom: 30px;

    &::after {
      position: absolute;
      left: 0;
      bottom: -2px;
      display: block;
      content: '';
      width: 280px;
      height: 2px;
      background-color: #C31424;
    }

    .left_text {
      position: absolute;
      left: 0;
      font-size: 18px;
      color: #999999;
      cursor: pointer;
      color: #a9a9ab;
    }

    .right_text {
      position: absolute;
      right: 0;
      font-size: 18px;
      cursor: pointer;
    }

    .center {
      font-size: 20px;
      color: #333333;
    }
  }

  .footerContent {
    // height: 92%;
    // border: 2px dashed #EDEEF1;
    max-width: 1200px;
    overflow: hidden;
    border: 2px solid #EDEEF1;
    // padding: 6px;
    font-size: 16px;
    color: #333333;
    box-sizing: border-box;

    .title_box {
      padding: 20px;
      box-sizing: border-box;
      height: 154px;
      border-bottom: 2px solid #EDEEF1;

      .title_1 {
        font-size: 16px;
        color: #333333;
        margin-bottom: 10px;
      }

      .title_2 {
        font-size: 14px;
        color: #333333;
        display: flex;
        justify-content: space-between;

        .download {
          display: flex;
          font-size: 14px;
          color: #999999;

          .btn {
            display: flex;
            align-items: flex-end;
          }
        }
      }
    }

    .upload {
      padding: 20px;
      height: 128px;
      border-bottom: 2px solid #EDEEF1;

      .title_1 {
        font-size: 16px;
        color: #333333;
        margin-bottom: 10px;
        font-weight: 600;
      }

      .title_2 {
        font-size: 14px;
        color: #333333;
        display: flex;
        align-items: center;

        .upload_btn {
          width: 90%;
          padding: 2px;
          margin-left: 10px;
          border: 3px solid #DEDEDE;
        }
      }
    }

    padding: 15px;

    .status {
      padding: 5px;
      font-size: 14px;
      color: #FFA100;
      border: 1px solid #ffa100;
      background-color: #fff6e5;
      border-radius: 3px;
    }

    .time_box {
      display: flex;
      margin-top: 25px;

      .time_item {
        width: 50%;
        font-size: 16px;
        color: #666666;
      }

      .shuXian {
        border-left: 1px solid #D8D8D8;
        padding-left: 21px;
      }
    }

    .xmjs {
      margin-top: 40px;

      .xmjs_text {
        font-size: 16px;
        color: #666666;
      }

      .content_text {
        padding: 3px 10px;
        background-color: #f4f4f4;
        font-size: 14px;
        color: #333333;
      }
    }

    .form {
      margin-top: 40px;

      .footer_item {
        display: flex;
        margin-bottom: 20px;

        .lable {
          min-width: 140px;
          font-size: 16px;
          color: #666666;
          // margin-right: 88px;
        }

        .value {
          .bzj {
            font-size: 16px;
            color: #333333;
            line-height: 23px;
            margin-bottom: 8px;

          }
        }

        .item_box {
          display: flex;
          flex-wrap: wrap;
        }

        .item_box:nth-child(6) .img_style {
          margin-right: 0 !important;
        }

        .upload1 {
          width: 100%;

          .upload_btn {
            width: 90%;
            padding: 2px;
            border: 3px solid #DEDEDE;
            margin-bottom: 8px;
          }
        }

        .footer_info {
          padding: 5px 22px;
          background-color: #f7f7f7 !important;
          border: 1px solid rgba(161, 161, 161, 0.1608);
          font-size: 12px;
          color: #999999;
        }
      }

    }
  }


}

.agreement-text {
  color: #666;
  font-size: 14px;
}

.header_4 {
  border: 1px solid #efefef;
  display: flex;
  flex-wrap: wrap;
  padding: 7px 0;

  .file_item {
    width: 19.5%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;

    .xz {
      color: #c31424;
      cursor: pointer;
    }
  }

  .shu_xian {
    border-right: 1px solid #f0f0f0;
  }
}
</style>